import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  campaign: drilldownData["campaign"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      imageDimension,
      disabledPreviousDateTime,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
      imageDimension,
      disabledPreviousDateTime,
    })
  ),
  homePageCarousel: drilldownData["homePageCarousel"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      options,
      usedFileType,
      imageDimension,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      usedFileType: usedFileType,
      imageDimension: imageDimension,
    })
  ),
  bannerPromotion: drilldownData["bannerPromotion"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      imageDimension,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      imageDimension: imageDimension,
    })
  ),
  bannerTopSelling: drilldownData["bannerTopSelling"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      imageDimension,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      imageDimension: imageDimension,
    })
  ),
  bannnerBrands: drilldownData["bannnerBrands"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      imageDimension,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      imageDimension: imageDimension,
    })
  ),
  bannerNews: drilldownData["bannerNews"].map(
    ({ fieldName, placeholder, name, formType, validation, className, imageDimension }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      imageDimension: imageDimension,
    })
  ),
};
